type MsalErrorLike = {
  error?: unknown;
  errorCode?: unknown;
  error_codes?: unknown;
  errorCodes?: unknown;
  error_description?: unknown;
  errorMessage?: unknown;
  message?: unknown;
  suberror?: unknown;
  subError?: unknown;
};

const EXPIRED_SPA_REFRESH_TOKEN_CODE = '700084';

function asLowerCaseString(value: unknown): string {
  return typeof value === 'string' ? value.toLowerCase() : '';
}

function hasExpiredSpaRefreshTokenCode(error: MsalErrorLike): boolean {
  const errorCodes = Array.isArray(error.error_codes)
    ? error.error_codes
    : Array.isArray(error.errorCodes)
    ? error.errorCodes
    : [];

  if (
    errorCodes.some((code) => String(code) === EXPIRED_SPA_REFRESH_TOKEN_CODE)
  ) {
    return true;
  }

  const description = [
    error.error_description,
    error.errorMessage,
    error.message,
  ]
    .filter((value): value is string => typeof value === 'string')
    .join(' ');

  return new RegExp(`\\bAADSTS${EXPIRED_SPA_REFRESH_TOKEN_CODE}\\b`, 'i').test(
    description,
  );
}

/**
 * AADSTS700084 is returned when a SPA refresh token reaches its fixed lifetime.
 * MSAL 2.x can expose the response either as a ServerError (camelCase fields)
 * or as the raw OAuth payload (snake_case fields), depending on the call path.
 */
export function isExpiredSpaRefreshTokenError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;

  const authError = error as MsalErrorLike;
  if (hasExpiredSpaRefreshTokenCode(authError)) return true;

  const errorCode = asLowerCaseString(authError.errorCode || authError.error);
  const subError = asLowerCaseString(authError.subError || authError.suberror);

  return errorCode === 'invalid_grant' && subError === 'bad_token';
}

/**
 * MSAL may replace the original invalid_grant with this browser error after
 * its hidden-iframe fallback times out. A top-level reauthentication is then
 * required because the silent flow can no longer make progress.
 */
export function isSilentTokenAcquisitionTimeoutError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;

  const authError = error as MsalErrorLike;
  const errorCode = asLowerCaseString(authError.errorCode || authError.error);

  return errorCode === 'monitor_window_timeout';
}
